import {
  roomCreate,
  roomGet,
  roomList,
  roomUpdate,
  roomUpdateAdminMemo,
  useRoomCreate,
  useRoomDelete,
  useRoomGetSuspense,
  useRoomList,
  useRoomListSuspense,
  useRoomUpdate,
  useRoomUpdateAdminMemo,
} from "@/api/generated/endpoints/api"
import {
  RoomGetWithOwnerMemos,
  RoomGetWithOwnerMemosFiles,
  RoomGetWithPlans,
  RoomGetWithProperty,
  RoomGetWithPropertyOwner,
  RoomGetWithTenants,
  RoomGetWithTenantsFiles,
  RoomGetWithTenantsOccupants,
  RoomListWithPlans,
  RoomListWithProperty,
  RoomListWithPropertyOwner,
  RoomListWithTenants,
  RoomListWithTenantsFiles,
} from "@/api/generated/models"
import {
  roomCreateBody,
  roomUpdateAdminMemoBody,
  roomUpdateBody,
} from "@/api/generated/schemas/api.zod"

// API hooks and functions
export const roomApi = {
  // Query hooks
  useRoomList,
  useRoomListSuspense,
  useRoomGetSuspense,

  // Mutation hooks
  useRoomCreate,
  useRoomUpdate,
  useRoomDelete,
  useRoomUpdateAdminMemo,

  // Direct API functions
  roomCreate,
  roomGet,
  roomList,
  roomUpdate,
  roomUpdateAdminMemo,
}

export const roomParams = {
  RoomGetWithOwnerMemos,
  RoomGetWithOwnerMemosFiles,
  RoomGetWithProperty,
  RoomGetWithPropertyOwner,
  RoomGetWithTenants,
  RoomGetWithTenantsFiles,
  RoomGetWithTenantsOccupants,
  RoomGetWithPlans,
  RoomListWithProperty,
  RoomListWithPropertyOwner,
  RoomListWithTenants,
  RoomListWithTenantsFiles,
  RoomListWithPlans,
}

export const roomSchemas = {
  roomCreateBody,
  roomUpdateBody,
  roomUpdateAdminMemoBody,
}

export * as RoomModels from "./models"
